import { VIDEO_CAMPAIGN_SUFFIX } from '../../../../../config/reportIdSuffixes';

export const ACCOUNT_MANAGER_GROUP_VIDEO_REPORT_ID = `account-manager-group${VIDEO_CAMPAIGN_SUFFIX}`;
